import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { legalConfig } from './legalConfig';

interface LegalLayoutProps {
  title: string;
  children: React.ReactNode;
}

export default function LegalLayout({ title, children }: LegalLayoutProps) {
  const [prefersDark, setPrefersDark] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    setPrefersDark(query.matches);
    const onChange = (event: MediaQueryListEvent) => setPrefersDark(event.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  useEffect(() => {
    document.title = `${title} — EBD Learning`;
    document.documentElement.lang = 'vi';
  }, [title]);

  return (
    <div className={prefersDark ? 'dark' : undefined}>
      <div className="min-h-screen bg-white text-slate-900 dark:bg-slate-900 dark:text-slate-100">
        <header className="border-b border-slate-200 bg-slate-50 py-7 dark:border-slate-700 dark:bg-slate-800">
          <div className="mx-auto max-w-3xl px-5">
            <div className="text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              EBD Learning
            </div>
            <h1 className="mt-2 text-2xl font-bold leading-snug">{title}</h1>
            <div className="text-sm text-slate-500 dark:text-slate-400">
              Có hiệu lực từ ngày {legalConfig.effectiveDate}
            </div>
          </div>
        </header>

        <main className="py-9">
          <div className="mx-auto max-w-3xl px-5 leading-7">{children}</div>
        </main>

        <footer className="border-t border-slate-200 py-6 text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
          <div className="mx-auto max-w-3xl px-5">
            <nav className="mb-2 flex flex-wrap gap-4">
              <Link className="text-blue-700 dark:text-blue-400" to="/privacy">
                Chính sách bảo mật
              </Link>
              <Link className="text-blue-700 dark:text-blue-400" to="/terms">
                Điều khoản sử dụng
              </Link>
              <Link className="text-blue-700 dark:text-blue-400" to="/delete-account">
                Xoá tài khoản
              </Link>
            </nav>
            <p>
              {legalConfig.company} — Mã số doanh nghiệp {legalConfig.taxCode}
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}
